import { render, staticRenderFns, recyclableRender, components } from "./shop-wallet.vue?vue&type=template&id=0a407a30&scoped=true&"
var renderjs
import script from "./shop-wallet.vue?vue&type=script&lang=js&"
export * from "./shop-wallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a407a30",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/shop-wallet/shop-wallet.vue"
export default component.exports